var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_391_13427"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 33,
    height: 33,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_391_13427)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.375,1.375L9.625,1.375C8.10622,1.375,6.875,2.60622,6.875,4.125L6.875,28.875C6.875,30.3938,8.10622,31.625,9.625,31.625L23.375,31.625C24.8938,31.625,26.125,30.3938,26.125,28.875L26.125,4.125C26.125,2.60622,24.8938,1.375,23.375,1.375Z",
    fill: "#707070",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.375,6.875L9.625,6.875L9.625,24.75L23.375,24.75L23.375,6.875Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.25,3.4375L13.75,3.4375L13.75,4.8125L19.25,4.8125L19.25,3.4375Z",
    fill: "#C7CED5",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5625,28.1875Q18.5625,28.28882,18.55257,28.38966Q18.54264,28.4905,18.52287,28.58987Q18.5031,28.68925,18.47369,28.78621Q18.44428,28.88317,18.4055,28.97678Q18.36673,29.0704,18.31896,29.15976Q18.2712,29.24912,18.21491,29.33336Q18.15861,29.41761,18.09433,29.49594Q18.03005,29.57426,17.95841,29.64591Q17.88676,29.71755,17.80844,29.78183Q17.73011,29.84611,17.64586,29.90241Q17.56162,29.9587,17.47226,30.00646Q17.3829,30.05423,17.28928,30.093Q17.19567,30.13178,17.09871,30.16119Q17.00175,30.1906,16.90237,30.21037Q16.803,30.23014,16.70216,30.24007Q16.60132,30.25,16.5,30.25Q16.39868,30.25,16.29784,30.24007Q16.197,30.23014,16.09763,30.21037Q15.99825,30.1906,15.90129,30.16119Q15.80433,30.13178,15.71072,30.093Q15.6171,30.05423,15.52774,30.00646Q15.43838,29.9587,15.354136,29.90241Q15.269888,29.84611,15.191564,29.78183Q15.113239,29.71755,15.041592,29.64591Q14.969945,29.57426,14.905666,29.49594Q14.841387,29.41761,14.785094,29.33336Q14.728801,29.24912,14.681037,29.15976Q14.633273,29.0704,14.594498,28.97678Q14.555723,28.88317,14.5263105,28.78621Q14.4968977,28.68925,14.4771304,28.58987Q14.457363,28.4905,14.4474315,28.38966Q14.4375,28.28882,14.4375,28.1875Q14.4375,28.08618,14.4474315,27.98534Q14.457363,27.8845,14.4771304,27.78513Q14.4968977,27.68575,14.5263105,27.58879Q14.555723,27.49183,14.594498,27.39822Q14.633273,27.3046,14.681037,27.21524Q14.728801,27.12588,14.785094,27.041636Q14.841387,26.957388,14.905666,26.879064Q14.969945,26.800739,15.041592,26.729092Q15.113239,26.657445,15.191564,26.593166Q15.269888,26.528887,15.354136,26.472594Q15.43838,26.416301,15.52774,26.368537Q15.6171,26.320773,15.71072,26.281998Q15.80433,26.243223,15.90129,26.2138105Q15.99825,26.1843977,16.09763,26.1646304Q16.197,26.144863,16.29784,26.1349315Q16.39868,26.125,16.5,26.125Q16.60132,26.125,16.70216,26.1349315Q16.803,26.144863,16.90237,26.1646304Q17.00175,26.1843977,17.09871,26.2138105Q17.19567,26.243223,17.28928,26.281998Q17.3829,26.320773,17.47226,26.368537Q17.56162,26.416301,17.64586,26.472594Q17.73011,26.528887,17.80844,26.593166Q17.88676,26.657445,17.95841,26.729092Q18.03005,26.800739,18.09433,26.879064Q18.15861,26.957388,18.21491,27.041636Q18.2712,27.12588,18.31896,27.21524Q18.36673,27.3046,18.4055,27.39822Q18.44428,27.49183,18.47369,27.58879Q18.5031,27.68575,18.52287,27.78513Q18.54264,27.8845,18.55257,27.98534Q18.5625,28.08618,18.5625,28.1875Z",
    fill: "#C7CED5",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhone);
export default __webpack_public_path__ + "static/media/i_phone.dfec8d0423a1df5fe4a13ec62553b7f2.svg";
export { ForwardRef as ReactComponent };